module.exports = __webpack_public_path__ + "static/step-1-fc6058d40497c3dfc8b417c1a32d43d5.png";